import {  IsNotEmpty, IsAlphanumeric, MaxLength, Matches, IsOptional, IsNumber } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
// import { StockTypeStatus  } from '@gtpl/shared-models/common-models';
export class RackSuggestionRequest {
    @ApiProperty()
    plantId:number;
    @ApiProperty()
    @IsNotEmpty()
    @IsAlphanumeric()
    saleOrderId: number;
    @ApiProperty()
    saleOrderItemId: number;
    @ApiProperty()
    mastersCartons: number;
    @ApiProperty()
    stockTypeStatus:string; 
    @ApiProperty()
    varientId?:number; 
    @ApiProperty()
    packStyleId?:number; 
    @ApiProperty()
    role?:string; 
}
